import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styles from "./NscNotifications.module.scss";
import { InfoIconWithMessage } from "../../../shared/infoIcon/InfoIcon";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import ClearIcon from "@material-ui/icons/Clear";
import MultiToggleWidget from "../../../shared/toggles/multiToggleWidget/MultiToggleWidget";
import EditIcon from "../../../shared/Edit/EditIcon";
import NscEmailNotificationsClient from "../../../shared/clients/NscEmailNotificationsClient";

class NscNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailAddressesLimitReached: false,
      addingNewContact: false,
      employeesToEdit: new Map(),
      newEmployee: this.refreshNewEmployee(),
      nscEmailPreferencesData: [],
    };
  }

  componentDidMount() {
    this.getNscEmailPreferencesData();
  }

  onSelectEmailNotification = (nsc, event) => {
    const selectedStatus = event.target.checked;

    NscEmailNotificationsClient.updateNscEmailNotifications(
      this.props.user,
      nsc,
      selectedStatus
    ).then(() => {
      const copy = [...this.state.nscEmailPreferencesData];
      const index = this.state.nscEmailPreferencesData.indexOf(
        this.state.nscEmailPreferencesData.filter((emp) => emp.id === nsc.id)[0]
      );
      const employeeToChange = copy[index];
      employeeToChange.notificationsEmail = selectedStatus;
      copy.splice(index, 1, employeeToChange);
      this.setState({ nscEmailPreferencesData: copy });
    });
  };

  onSelectPriceChangeNotification = (nsc, event) => {
    const selectedStatus = event.target.checked;

    NscEmailNotificationsClient.updateNscPriceChangeEmailNotifications(
      this.props.user,
      nsc,
      selectedStatus
    ).then(() => {
      const copy = [...this.state.nscEmailPreferencesData];
      const index = this.state.nscEmailPreferencesData.indexOf(
        this.state.nscEmailPreferencesData.filter((emp) => emp.id === nsc.id)[0]
      );
      const employeeToChange = copy[index];
      employeeToChange.pendingActionEmail = selectedStatus;
      copy.splice(index, 1, employeeToChange);
      this.setState({ nscEmailPreferencesData: copy });
    });
  };

  updateEmployee = (employee) => {
    NscEmailNotificationsClient.updateNscNameAndEmailAddress(
      this.props.user,
      employee
    ).then((updateEmployee) => {
      const copy = [...this.state.nscEmailPreferencesData];
      const index = this.state.nscEmailPreferencesData.indexOf(
        this.state.nscEmailPreferencesData.filter(
          (emp) => emp.id === updateEmployee.id
        )[0]
      );
      copy.splice(index, 1, updateEmployee);
      this.setState({ nscEmailPreferencesData: copy });
      this.resetRow(updateEmployee.id);
    });
  };

  refreshNewEmployee() {
    return {
      id: "",
      fullName: "",
      emailAddress: "",
      notificationsEmail: true,
      market: this.props.selectedMarket,
    };
  }

  editEmployeeNameOnChange = (employeeId, event) => {
    const modifiedName = event.target.value;
    this.setState((prevState) => {
      const copy = new Map(prevState.employeesToEdit);
      const newEmployee = {
        ...copy.get(employeeId),
        fullName: modifiedName,
      };
      return { employeesToEdit: copy.set(employeeId, newEmployee) };
    });
  };

  editEmployeeEmailOnChange = (employeeId, event) => {
    const modifiedEmail = event.target.value;
    this.setState((prevState) => {
      const copy = new Map(prevState.employeesToEdit);
      const newEmployee = {
        ...copy.get(employeeId),
        emailAddress: modifiedEmail,
      };
      return { employeesToEdit: copy.set(employeeId, newEmployee) };
    });
  };

  resetRow = (employeeId) => {
    const nscId = parseInt(employeeId);
    if (this.state.employeesToEdit.has(nscId)) {
      const idToRemove = this.state.employeesToEdit.get(nscId).id;
      const copy = new Map(this.state.employeesToEdit);
      copy.delete(idToRemove);
      this.setState({ employeesToEdit: copy });
    }
  };

  cancelEdit = (event) => {
    this.resetRow(event.currentTarget.value);
  };

  addNewEmployee = () => {
    NscEmailNotificationsClient.addNscContactInfo(
      this.props.user,
      this.state.newEmployee
    )
      .then((newNsc) => {
        this.setState({
          nscEmailPreferencesData:
            this.state.nscEmailPreferencesData.concat(newNsc),
          addingNewContact: false,
          newEmployee: {
            id: "",
            fullName: "",
            emailAddress: "",
            notificationsEmail: true,
            market: this.props.selectedMarket,
          },
        });
      })
      .finally(() =>
        this.setState({
          emailAddressesLimitReached:
            this.state.nscEmailPreferencesData.length > 9,
        })
      );
  };

  editExistingEmployee = (event) => {
    const editEmployee = this.state.nscEmailPreferencesData.filter(
      (nsc) => nsc.id === parseInt(event.currentTarget.value)
    )[0];
    const copy = new Map(this.state.employeesToEdit);
    copy.set(editEmployee.id, editEmployee);
    this.setState({ employeesToEdit: copy });
  };

  deleteExistingNsc = (event) => {
    const nscId = parseInt(event.currentTarget.value);
    NscEmailNotificationsClient.deleteNscContactInfo(
      this.props.user,
      nscId
    ).then(() => {
      const copy = [...this.state.nscEmailPreferencesData];
      const index = this.state.nscEmailPreferencesData.indexOf(
        this.state.nscEmailPreferencesData.filter((emp) => emp.id === nscId)[0]
      );
      copy.splice(index, 1);
      this.setState({
        nscEmailPreferencesData: copy,
        emailAddressesLimitReached: copy.length > 9,
      });
    });
  };

  showNewEmployeeRow = () => {
    this.setState({ addingNewContact: true });
  };

  newEmployeeNameOnChange = (event) => {
    this.setState({
      newEmployee: {
        ...this.state.newEmployee,
        fullName: event.target.value,
      },
    });
  };

  newEmployeeEmailOnChange = (event) => {
    this.setState({
      newEmployee: {
        ...this.state.newEmployee,
        emailAddress: event.target.value,
      },
    });
  };

  getNscEmailPreferencesData = () => {
    NscEmailNotificationsClient.getNscEmailNotificationsData(
      this.props.user,
      this.props.selectedMarket
    )
      .then((nsc) => {
        this.setState({
          nscEmailPreferencesData: nsc,
          emailAddressesLimitReached: nsc.length > 9,
        });
      })
      .catch(() => {});
  };

  cancelAddingNewContact = () => {
    this.setState({
      addingNewContact: false,
      newEmployee: this.refreshNewEmployee(),
    });
  };

  render() {
    return (
      <>
        <div className="pageInfoWrapper pagePaddingLeft pagePaddingTop pagePaddingRight">
          <InfoIconWithMessage
            message={this.props.t("NscNotifications.pageInfo")}
          />
        </div>

        <div className={styles.title}>
          <h2 className="pagePaddingLeft" id="termsHeader">
            {this.props.t("NscNotifications.header")}
          </h2>
        </div>

        {this.state.nscEmailPreferencesData.length > 0 && (
          <div className={styles.nscEmailHeader}>
            {/* Populates the Header of the Table */}
            <Grid container className={styles.subHeader}>
              <Grid item md={3} className={styles.employeeInfoHeader}>
                {this.props.t("DealerShipDetails.employees")}
              </Grid>
              <Grid item md={3} className={styles.employeeInfoHeader}>
                {this.props.t("DealerShipDetails.employeesEmail")}
              </Grid>
              <Grid item md={2} className={styles.notifications}>
                <div>
                  {this.props.t("NscNotifications.receiveEmailsToggleHeader")}
                </div>
              </Grid>
              <Grid item md={2} className={styles.notifications}>
                <div>
                  {this.props.t(
                    "NscNotifications.receivePricingEmailsToggleHeader"
                  )}
                </div>
              </Grid>
            </Grid>

            {/* Populates the body of the table. If employeesToEdit has employeeId, then open validator form, else render normal table rows */}
            {this.state.nscEmailPreferencesData.map((nsc, index) => (
              <div key={`employee_${index}`}>
                {this.state.employeesToEdit.has(nsc.id) ? (
                  <ValidatorForm
                    onSubmit={() =>
                      this.updateEmployee(
                        this.state.employeesToEdit.get(nsc.id)
                      )
                    }
                  >
                    <Grid
                      container
                      className={`${styles.tableBody} ${styles.nscInfo}`}
                    >
                      <Grid item md={3} className={styles.nscFullName}>
                        <TextValidator
                          name={`fullName_${nsc.id}`}
                          style={{ width: "70%" }}
                          value={
                            this.state.employeesToEdit.get(nsc.id).fullName
                          }
                          variant="outlined"
                          validators={["required"]}
                          onChange={(e) =>
                            this.editEmployeeNameOnChange(nsc.id, e)
                          }
                          errorMessages={[this.props.t("Error.requiredField")]}
                        />
                      </Grid>
                      <Grid item md={3} className={styles.nscEmail}>
                        <TextValidator
                          name={`email_${nsc.id}`}
                          style={{ width: "70%" }}
                          value={
                            this.state.employeesToEdit.get(nsc.id).emailAddress
                          }
                          variant="outlined"
                          validators={["required", "isEmail"]}
                          onChange={(e) =>
                            this.editEmployeeEmailOnChange(nsc.id, e)
                          }
                          errorMessages={[
                            this.props.t("Error.requiredField"),
                            this.props.t("Error.invalidInput"),
                          ]}
                        />
                      </Grid>
                      <Grid item className={styles.nscSwitches} md={2}>
                        {nsc.notificationsEmail
                          ? this.props.t("GeneralEMP.statusYes")
                          : this.props.t("GeneralEMP.statusNo")}
                      </Grid>
                      <Grid item className={styles.nscSwitches} md={2}>
                        {nsc.pendingActionEmail
                          ? this.props.t("GeneralEMP.statusYes")
                          : this.props.t("GeneralEMP.statusNo")}
                      </Grid>
                      <Grid item md={2} className={styles.editDiv}>
                        <Button
                          id={`updateEmployee_${nsc.id}`}
                          data-testid={`updateEmployee_${nsc.id}`}
                          value={nsc.id}
                          type="submit"
                          disabled={false}
                        >
                          <div className={styles.confirm}>OK</div>
                        </Button>
                        <Button
                          id={`cancelEdit_${nsc.id}`}
                          data-testid={`cancelEdit_${nsc.id}`}
                          value={nsc.id}
                          onClick={this.cancelEdit}
                        >
                          <ClearIcon />
                        </Button>
                      </Grid>
                    </Grid>
                  </ValidatorForm>
                ) : (
                  <Grid container className={styles.nscInfo} key={index}>
                    <Grid
                      item
                      md={3}
                      id={`name_${index}`}
                      className={styles.nscFullName}
                    >
                      {nsc.fullName}
                    </Grid>
                    <Grid
                      item
                      md={3}
                      id={`email_${index}`}
                      className={styles.nscEmail}
                    >
                      {nsc.emailAddress}
                    </Grid>
                    <Grid item md={2} className={styles.switches}>
                      <MultiToggleWidget
                        {...this.props}
                        isToggleDisabled={false}
                        settings={{
                          acceptedText: this.props.t("GeneralEMP.statusYes"),
                          rejectedText: this.props.t("GeneralEMP.statusNo"),
                          suppClass: `${styles.toggleWrapper}`,
                          toggleLabel: `${styles.activationToggle}`,
                        }}
                        fromDealerTable={true}
                        isMainViewingSDLR=""
                        toggleName={`emailNot_${nsc.id}`}
                        currentStatus={nsc.notificationsEmail ? "yes" : "no"}
                        onSelect={(e) => this.onSelectEmailNotification(nsc, e)}
                      />
                    </Grid>
                    <Grid item md={2} className={styles.switches}>
                      <MultiToggleWidget
                        {...this.props}
                        isToggleDisabled={false}
                        settings={{
                          acceptedText: this.props.t("GeneralEMP.statusYes"),
                          rejectedText: this.props.t("GeneralEMP.statusNo"),
                          suppClass: `${styles.toggleWrapper}`,
                          toggleLabel: `${styles.activationToggle}`,
                        }}
                        fromDealerTable={true}
                        isMainViewingSDLR=""
                        toggleName={`pendingNot_${nsc.id}`}
                        currentStatus={nsc.pendingActionEmail ? "yes" : "no"}
                        onSelect={(e) =>
                          this.onSelectPriceChangeNotification(nsc, e)
                        }
                      />
                    </Grid>
                    {!(
                      this.props.userDetails &&
                      this.props.userDetails.fromPoNscSearch
                    ) && (
                      <Grid item md={2} className={styles.editDiv}>
                        <Button
                          id={`editNsc_${nsc.id}`}
                          data-testid={`editNsc_${nsc.id}`}
                          value={nsc.id}
                          disabled={false}
                          onClick={this.editExistingEmployee}
                        >
                          <EditIcon />
                        </Button>
                        <Button
                          id={`deleteNsc${nsc.id}`}
                          data-testid={`deleteNsc_${nsc.id}`}
                          value={nsc.id}
                          disabled={false}
                          onClick={this.deleteExistingNsc}
                        >
                          <ClearIcon />
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                )}
              </div>
            ))}
          </div>
        )}

        {/* After having pressed '+ADD CONTACT' this div Renders the 'Name' and 'Email' input fields  as well as 'OK' and 'X' buttons */}
        <div
          className={`pagePaddingLeft pagePaddingRight ${styles.editButton}`}
        >
          {this.state.addingNewContact && (
            <ValidatorForm onSubmit={this.addNewEmployee}>
              <Grid className={styles.newEmployeeContainer} container>
                <Grid item md={3}>
                  <TextValidator
                    style={{ width: "70%" }}
                    name="inputName"
                    value={this.state.newEmployee.fullName}
                    variant="outlined"
                    placeholder="Full Name"
                    onChange={this.newEmployeeNameOnChange}
                    validators={["required"]}
                    errorMessages={[this.props.t("Error.requiredField")]}
                  />
                </Grid>
                <Grid item md={3}>
                  <TextValidator
                    style={{ width: "70%" }}
                    name="inputEmail"
                    value={this.state.newEmployee.emailAddress}
                    variant="outlined"
                    placeholder="Email Address"
                    onChange={this.newEmployeeEmailOnChange}
                    validators={["required", "isEmail"]}
                    errorMessages={[
                      this.props.t("Error.requiredField"),
                      this.props.t("Error.invalidInput"),
                    ]}
                  />
                </Grid>
                <Grid item md={4} />
                <Grid className={styles.actionDiv} item md={2}>
                  <Button
                    id="submitBtn"
                    data-testid="submitBtnTest"
                    disabled={false}
                    type="submit"
                  >
                    <div className={styles.confirm}>OK</div>
                  </Button>
                  <Button
                    id="cancelAdd_test"
                    data-testid="cancelAddingNewContactBtn"
                    onClick={this.cancelAddingNewContact}
                  >
                    <ClearIcon />
                  </Button>
                </Grid>
              </Grid>
            </ValidatorForm>
          )}

          <Button
            data-testid="addNewContactInfoButton"
            disabled={
              this.state.addingNewContact ||
              this.state.emailAddressesLimitReached ||
              (this.props.userDetails && this.props.userDetails.fromPoNscSearch)
            }
            onClick={this.showNewEmployeeRow}
          >
            {this.props.t("DealerShipDetails.addButton")}
          </Button>

          {this.state.emailAddressesLimitReached && (
            <div className={styles.maximumEmployee}>
              {this.props.t("DealerShipDetails.maxEmployee")}
            </div>
          )}
        </div>
      </>
    );
  }
}

export default withTranslation("emp")(NscNotifications);
